import React from 'react'
import PropTypes from 'prop-types'
import merge from 'lodash/merge'
import Standard from './Standard'

class Numeric extends React.Component {
  static propTypes = {
    validations: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    allowDefaultZero: PropTypes.bool,
  }

  static defaultProps = {
    validations: {},
    allowDefaultZero: true,
  }

  render = () => {
    const { validations, value, allowDefaultZero, ...other } = this.props

    return (
      <Standard
        type='number'
        alignRight
        value={allowDefaultZero ? value || '0' : value}
        validations={merge({}, validations, { isNumeric: true })}
        {...other}
      />
    )
  }
}

export default Numeric
